/* prettier-ignore */

import { Component, computed, effect, inject, input, InputSignal, signal, ViewEncapsulation } from '@angular/core';
import { RequestService } from './service/request.service';
import { tap } from 'rxjs';
import { ChatStyles } from './interface/chatStyles.interface';
import { History, Record } from './interface/history.interface';
import { DataChatService } from './service/dataChat.service';
import { Location } from '@angular/common';
import { ChatViewComponent } from './presentation/chatView/chatView.component';
import { ToolsService } from 'src/app/services/tools.service';
import { DebugService } from 'src/app/services/debug.service';
import { ScrollService } from './service/scrollContainer.service';
import { WebSocketService } from './service/webSocket.service';
import { StatisticsService } from 'src/app/services/statistics.service';
import { CUSTOM_ROUTE_MOBILE_MAP } from 'src/app/pages/custom-route/components/custom-route-mobile/config/constants';
import { SessionStorageService } from 'src/app/services/session-storage.service';

@Component({
  selector: 'app-chatbot',
  imports: [ChatViewComponent],
  standalone: true,
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class NewChatBotComponent {
  private statistics = inject(StatisticsService)
  private webSocketService = inject(WebSocketService);
  private debugService = inject(DebugService);
  private _sessionStorageService = inject(SessionStorageService);
  
  public requestService = inject(RequestService);
  public toolsService = inject(ToolsService)
  public dataChat = inject(DataChatService);
  public location = inject(Location);
  public scrollService = inject(ScrollService);

  public messagesFromStorage: string = '';

  public baseUrl: string = '';
  private token?: string;

  //SE ESTABLECE EL CHAT A MOSTRAR
  public chatID: InputSignal<string> = input.required<string>();  

  ngAfterViewInit() {
    this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.planner);
    this.startChatBot();
  }

  startChatBot() {
    if (!this.chatID()) 
      return;

    this.dataChat.id.set(this.chatID());
    this.token = this.statistics.sessionId;
    this.debugService.info(this.token, '[ChatBotComponent] TOKENCHAT');
    this.dataChat.token.set(this.token);
    
    // this.webSocketService.connectAll();
    this.webSocketService.connectAll();
    if (this.dataChat.messages()?.length > 1)
      return;

    if (this.webSocketService.historyChat?.length){
      this.dataChat.messages.set(this.webSocketService.historyChat)
      return;
    }

    this.webSocketService.getHistory().subscribe(res => {
      const data = JSON.parse(res?.conversations);
      data?.entries?.forEach(e => {
        if (e.message_id)
          return;
        
        this.dataChat.messages.update((prev) => [
          ...prev,
          {
            role: e.is_chatbot ? 'assistant' : 'user',
            content: e.content,
            show: true,
          },
        ]);
      });
      this.webSocketService.historyChat = this.dataChat.messages();
      this.scrollService.scrollToBottom()
    })

    // if (!this.messagesFromStorage) return;
    // let messageParsed = JSON.parse(this.messagesFromStorage);
    // this.dataChat.messages.set(messageParsed.messages);
    // return;
  }

  public e = effect(() => {
    if (this.dataChat.id() && !this.dataChat.requestIsFulliled()) {
      this.requestService
        .getChatDataStyles()
        .pipe(
          tap((res) => {
            let data: ChatStyles = res.data;
            this.dataChat.recommendedMessages.set(
              data.recommended_messages || []
            );

            this.checkInitialMessages(data)
          })
        )
        .subscribe((res) => {
          this.debugService.debug(res, '[ChatBotComponent] ChatBot Styles API Response');
          let data: ChatStyles = res.data;
          this.dataChat.icon.set(data.logo);
          this.dataChat.chatIcon.set(data.icon)
          this.dataChat.tooltipMsg.set( data.initial_messages?.[0]);
          this.dataChat.inputLeads.set(data.inputs_leads ?? [null, null]);
          if (this.dataChat.inputLeads()?.some((inp) => inp !== null))
            this.dataChat.hasSaveChat.set(true);
        });
    }

    if (this.dataChat.hasToken() && this.dataChat.requestIsFulliled()) {
      if (this.dataChat.isAzure()) {
        this.requestService
          .getHistory()
          .pipe(
            tap((res) => this.getChatHistory(res)))
          .subscribe();
        return;
      }
      this.requestService
        .getHistoryChatbase()
        .pipe(
          tap((res) => this.getChatHistory(res))
        )
        .subscribe();
    }
  });

  checkInitialMessages(data: ChatStyles){
    if(data.initial_messages){

      data.initial_messages.forEach((initialMessage: string) => {
        let message = {
          role: 'assistant',
          content: initialMessage,
          show: true,
        };

        this.dataChat.messages.update((prev) => [...prev, message]);

        this.dataChat.messagesForChatBase.update((prev) => [
          ...prev,
          {
            role: message.role,
            content: message.content,
          },
        ]);
        return
      });
    }

  }

  getChatHistory(res: Record){
    let history: History[] = res.record;
    if (!history) return;

    history.forEach((h) => {
      this.dataChat.messages.update((prev) => [...prev, h]);
    });
    this.dataChat.hasHistory.set(true);
    this.dataChat.canSaveChat.set(true);
  }

}
